import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Handle, Position } from 'react-flow-renderer';
import { Fetcher } from '../../../../Helpers/fetcher';
import { Notify } from '../../../../Helpers/notification';
import { DTMF_KEYS } from '../../../../Helpers/constant';
import { NodesContext } from '../../provider/IvrContext';
import AudioPreviewModal from '../AudioPreviewModal';

const DtmfNode = ({ data, id }) => {
    const { smsWebhookList, updateNodeData, onRemove, apiPath } = useContext(NodesContext);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [smsModalIsOpen, setSmsModalIsOpen] = useState(false);
    const [audio, setAudio] = useState([]);
    const [noInputFileList, setNoInputFileList] = useState([]);
    const [wrongInputFileList, setWrongInputFileList] = useState([]);
    const [welcomeFileList, setWelcomeFileList] = useState([]);
    const [errors, setErrors] = useState({});
    const [ttsTypeListApi, setTtsTypeListApi] = useState([]);
    const [tempSmsData, setTempSmsData] = useState({});
    const [smsErrors, setSmsErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);
    // const [manualDigits, setManualDigit] = useState(data?.manualDigits ?? null);

    const {
        action = {},
        type = "",
        numDigits = 1,
        timeout = "",
        numSources = [],
        rePrompt = "",
        ttsRows = [],
        minValue = "",
        selectedHandles = {},
        smsData = {},
    } = data;
    const menuAudioUrl = action?.menu?.audio || "";
    const menuAudioName = action?.menu?.name || "";

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);
    const openSmsModal = () => {
        setTempSmsData(JSON.parse(JSON.stringify(smsData || {})));
        setSmsErrors({});
        setSmsModalIsOpen(true);
    };
    const closeSmsModal = () => {
        setTempSmsData({});
        setSmsErrors({});
        setSmsModalIsOpen(false);
    };
    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                const resp = await Fetcher.get(`${apiPath}/api/obd/prompts/${data.userId}`);
                if (!Array.isArray(resp)) return;

                setAudio(resp.filter(item => item.promptCategory === 'menu' && item.promptStatus === 1));
                setNoInputFileList(resp.filter(item => item.promptCategory === 'noinput' && item.promptStatus === 1));
                setWrongInputFileList(resp.filter(item => item.promptCategory === 'wronginput' && item.promptStatus === 1));
                setWelcomeFileList(resp.filter(item => item.promptCategory === 'welcome' && item.promptStatus === 1));
            } catch (err) {
                console.error(err);
            }
        };

        const fetchTtsTypes = async () => {
            try {
                const res = await Fetcher.get(`${apiPath}/api/obd/tts/type/list`);
                setTtsTypeListApi(res);
            } catch (err) {
                console.error(err);
            }
        };

        fetchPrompts();
        fetchTtsTypes();
    }, [apiPath, data.userId]);

    const updateNode = (updates) =>
        updateNodeData(id, { ...data, ...updates });

    const toggleSmsEnable = (key) => {
        setTempSmsData(prev => {
            const updated = { ...prev };
            updated[key] ? delete updated[key] : (updated[key] = {});
            return updated;
        });
    };

    const validateSmsData = () => {
        const errors = {};

        Object.keys(tempSmsData).forEach(key => {
            if (!tempSmsData[key]?.payload) {
                errors[key] = "Webhook is required";
            }
        });

        setSmsErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const updateSmsUrl = (key, e) => {
        const option = e.target.selectedOptions[0];

        setTempSmsData(prev => ({
            ...prev,
            [key]: {
                payload: option.value,
                id: option.dataset.id,
            },
        }));
    };

    const saveSmsData = () => {
        if (!validateSmsData()) return;

        updateNode({ smsData: tempSmsData });
        Notify.notify("SMS Configuration Saved");
        closeSmsModal();
    };

    // const handleInputChange = (e) => {
    //     const { name, value, type, checked } = e.target;

    //     const audioSelectors = {
    //         audioId: { list: audio, urlKey: 'audioUrl' },
    //         noInputFileId: { list: noInputFileList, urlKey: 'noInputFileUrl' },
    //         wrongInputFileId: { list: wrongInputFileList, urlKey: 'wrongInputFileUrl' },
    //         promptId: { list: [...welcomeFileList, ...audio], urlKey: 'promptUrl' },
    //     };

    //     if (audioSelectors[name]) {
    //         const selected = audioSelectors[name].list.find(item => item.promptId.toString() === value);
    //         setInputFormData(prev => ({ ...prev, [name]: value, [audioSelectors[name].urlKey]: selected?.promptUrl }));
    //     } else {
    //         setInputFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    //     }
    // };

    const toggleHandle = (index) => {
        const handleId = `${id}_handle-${index}`;
        const updated = { ...selectedHandles };

        if (updated[handleId]) delete updated[handleId];
        else updated[handleId] = {
            type: "source",
            position: "bottom",
            left: index * 10 + 10,
        };

        updateNode({
            selectedHandles: updated,
            numSources: Object.keys(updated).map(h => Number(h.split("-")[1])),
        });
    };
    const updateActionAudio = (key, list, value) => {

        if (value === "") {
            updateNode({
                action: {
                    ...action,
                    [key]: null,
                },
            });
            return;
        }

        const selected = list.find(i => i.promptId.toString() === value);
        if (!selected) return;

        updateNode({
            action: {
                ...action,
                [key]: { id: selected.promptId, audio: selected.promptUrl, duration: selected?.promptDuration ?? 0, name: selected.fileName },
            },
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!action?.menu?.id) {
            newErrors.audio = 'Audio is required';
        }
        if (timeout === '' || timeout === null) newErrors.timeout = 'Wait time is required';

        const digitCount = Number(numDigits);

        // if (digitCount > 1) {
        //     if (!manualDigits) {
        //         newErrors.manualDigits = `Enter exactly ${digitCount} digits`;
        //     } else if (manualDigits.length !== digitCount) {
        //         newErrors.manualDigits = `Must be exactly ${digitCount} digits`;
        //     }
        // }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateForm()) return;

        // updateNode({
        //     minValue: Math.min(...numSources),
        // });

        // updateNode({ manualDigits: manualDigits });
        Notify.notify('Detail Added Successfully');
        closeModal();
    };

    // const handleAddAction = () => {
    //     const { actionType, promptId, promptUrl, variableNumber, variableType } = inputFormData;

    //     if (!actionType) return Notify.notify('Please select Action Type');

    //     if (actionType === 'prompt') {
    //         if (!promptId) return Notify.notify('Please select a Prompt');
    //         setTtsRows(prev => [...prev, { type: 'prompt', value: promptId, url: promptUrl, variableType: '' }]);
    //     } else if (actionType === 'variable') {
    //         if (!variableNumber) return Notify.notify('Please select Variable Number');
    //         if (!variableType) return Notify.notify('Please select Variable Type');

    //         const lowest = Math.min(...valueList);
    //         if (Number(variableNumber) !== lowest) return Notify.notify(`Please select Variable ${lowest} first`);

    //         setTtsRows(prev => [...prev, { type: 'variable', value: variableNumber, variableType }]);
    //         setValueList(prev => prev.filter(v => v !== Number(variableNumber)));
    //         setInputFormData(prev => ({ ...prev, variableNumber: '' }));
    //     }
    // };

    // const handleDeleteRow = (index) => {
    //     const rows = [...ttsRows];
    //     const deleted = rows.splice(index, 1)[0];
    //     if (deleted.type === 'variable') setValueList(prev => [...prev, Number(deleted.value)].sort((a, b) => a - b));
    //     setTtsRows(rows);
    // };

    const renderedHandles = useMemo(() => Object.entries(selectedHandles).map(([handleId, handle]) => (
        <Handle key={handleId} type={handle.type} position={handle.position} id={handleId} style={{ left: `${handle.left}px`, backgroundColor: 'purple', width: 8, height: 8 }} />
    )), [selectedHandles]);
    const renderSingle = useMemo(() => (
        <Handle
            id={`${id}_single_source`}
            type="source"
            position={Position.Bottom}
            isConnectable={Number(numDigits) !== 1}
            style={{
                backgroundColor: 'purple',
                width: 8,
                height: 8,
                opacity: Number(numDigits) !== 1 ? 1 : 0,
                pointerEvents: Number(numDigits) !== 1 ? 'auto' : 'none',
            }}
        />
    ), [numDigits, id]);

    return (
        <div style={{
            width: Object.keys(selectedHandles).length === 0 ? 100 : Object.keys(selectedHandles).length + 120,
            height: 40,
            border: '2px solid purple',
            borderRadius: 12,
            background: '#fff',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
            transition: '0.3s ease-in-out'
        }}>
            <Handle type="target" position="top" id={id} style={{ left: '50%', transform: 'translateX(-50%)', backgroundColor: 'purple', width: 8, height: 8 }} />
            {renderedHandles}
            {renderSingle}
            <span style={{ fontSize: 11, fontWeight: 'bold', color: '#333', textAlign: 'center', textTransform: 'capitalize' }}>DTMF Node</span>

            <div style={{ display: 'flex', gap: 10 }}>
                <i className="fa fa-cog" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Settings" onClick={openModal} />
                <i className="fa fa-trash" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Remove" onClick={() => onRemove(id)} />
                {Boolean(Object.keys(selectedHandles).length) && <i className="fa fa-envelope-o" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Message" onClick={openSmsModal} />}
                {menuAudioUrl && (
                    <i
                        className="fa fa-play"
                        style={{ color: 'green', fontSize: 14, cursor: 'pointer' }}
                        title="Play Menu Audio"
                        onClick={() => setPlayModalOpen(true)}
                    />
                )}
            </div>

            <Modal show={modalIsOpen} onHide={closeModal} backdrop="static" style={{ zIndex: 1050 }} size="lg">
                <Modal.Header closeButton><Modal.Title>DTMF Node Settings</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Type:</Form.Label>
                                <Form.Control as="select" name="type" value={type} onChange={e => updateNode({ type: e.target.value })}>
                                    <option value="">Select Type</option>
                                    <option value="digits">Digits</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Select Audio</Form.Label>
                                <Form.Control as="select" name="audioId" value={action.menu?.id || ""}
                                    onChange={e => updateActionAudio("menu", audio, e.target.value)}>
                                    <option value="">Select Audio</option>
                                    {audio.map(a => <option key={a.promptId} value={a.promptId}>{a.fileName}</option>)}
                                </Form.Control>
                                {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                            </Form.Group>
                        </div>

                        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Num Digits:</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="numDigits"
                                    value={numDigits}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        updateNode({
                                            numDigits: value,
                                        });
                                    }}
                                    onBlur={() => {
                                        let finalValue = Number(numDigits);

                                        if (!finalValue || finalValue < 1) {
                                            finalValue = 1;
                                        }

                                        // if (finalValue === 1) {
                                        //     updateNode({
                                        //         numDigits: finalValue,
                                        //     });
                                        //     setManualDigit("");
                                        // } else {

                                            updateNode({
                                                numDigits: finalValue,
                                                selectedHandles: {},
                                            });
                                        // }
                                    }}
                                />
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Wait Time (s):</Form.Label>
                                <Form.Select name="timeout" value={timeout}
                                    onChange={e => updateNode({ timeout: e.target.value })}>
                                    <option value="">Select Wait Time</option>
                                    {numDigits > 1
                                        ? [4,5].map(n => (
                                            <option key={n} value={n}>
                                                {n}
                                            </option>
                                            ))
                                        : Array.from({ length: 20 }, (_, i) => i + 1).map(n => (
                                            <option key={n} value={n}>
                                                {n}
                                            </option>
                                            ))
                                    }
                                </Form.Select>
                                {errors.timeout && <Form.Text className="text-danger">{errors.timeout}</Form.Text>}
                            </Form.Group>
                        </div>

                        {/* No Input & Wrong Input Files */}
                        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>No Input File:</Form.Label>
                                <Form.Select name="noInputFileId" value={action?.noInputFileId?.id} onChange={e => updateActionAudio("noInputFileId", noInputFileList, e.target.value)}>
                                    <option value="">Select No-Input File</option>
                                    {noInputFileList.map(a => <option key={a.promptId} value={a.promptId}>{a.fileName}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Wrong Input File:</Form.Label>
                                <Form.Select name="wrongInputFileId" value={action?.wrongInputFileId?.id} onChange={e => updateActionAudio("wrongInputFileId", wrongInputFileList, e.target.value)}>
                                    <option value="">Select Wrong-Input File</option>
                                    {wrongInputFileList.map(a => <option key={a.promptId} value={a.promptId}>{a.fileName}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Re-Prompt Count:</Form.Label>
                                <Form.Control as="select" name="rePrompt" value={rePrompt} onChange={(e) => updateNode({ rePrompt: e.target.value })}>
                                    <option value="">Select Re-Prompt Count</option>
                                    {[0, 1, 2, 3].map(n => <option key={n} value={n}>{n}</option>)}
                                </Form.Control>
                            </Form.Group>
                        </div>


                        <Form.Group style={{ marginTop: 10 }}>
                            {Number(numDigits) === 1 &&
                                <>
                                    <Form.Label>Digits (Select Values):</Form.Label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                                        {DTMF_KEYS.map((key, idx) => (
                                            <label key={idx}>
                                                <input type="checkbox" checked={selectedHandles[`${id}_handle-${idx}`] !== undefined} onChange={() => toggleHandle(idx)} style={{ marginRight: 5 }} />
                                                {key}
                                            </label>
                                        ))}
                                    </div>
                                </>
                                // : <>
                                // <Form.Control
                                //     type="number"
                                //     placeholder={`Enter exactly ${numDigits} digit${numDigits > 1 ? 's' : ''}`}
                                //     value={manualDigits || ''}
                                //     onChange={(e) => {
                                //         const value = e.target.value.replace(/\D/g, "").slice(0, numDigits);
                                //         setManualDigit(value);
                                //     }}
                                // /></>
                                }
                            {/* {errors.manualDigits && (
                                <Form.Text className="text-danger">
                                    {errors.manualDigits}
                                </Form.Text>
                            )} */}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>Add</Button>
                    <Button variant="secondary" onClick={closeModal}>Discard</Button>
                </Modal.Footer>
            </Modal>

            {/* SMS Modal */}
            <Modal
                size="lg"
                show={smsModalIsOpen}
                onHide={closeSmsModal}
                backdrop="static"
                style={{ zIndex: 1050 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>DTMF SMS Modal</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
                    {Object.keys(selectedHandles).length === 0 ? (
                        <p>No DTMF key selected.</p>
                    ) : (
                        Object.keys(selectedHandles).map((handleKey) => {
                            const index = handleKey.split('-')[1];
                            const keyLabel = DTMF_KEYS[index];
                            const lable = `DTMF_${keyLabel}`
                            const checked = !!tempSmsData[lable];
                            return (
                                <Form.Group className="mb-3" key={handleKey}>
                                    <Form.Check
                                        type="checkbox"
                                        id={`dtmf-${index}`}
                                        label={`DTMF ${keyLabel}`}
                                        checked={checked}
                                        required
                                        onChange={() => toggleSmsEnable(lable)}
                                    />
                                    {checked && smsWebhookList && smsWebhookList.length > 0 && (
                                        <>
                                            <Form.Select
                                                className="mt-2"
                                                value={tempSmsData[lable]?.payload || ""}
                                                onChange={(e) => updateSmsUrl(lable, e)}
                                            >
                                                <option value="">Select SMS Webhook</option>
                                                {smsWebhookList.map((obj, idx) => {
                                                    const valueObj = {
                                                        url: obj.url,
                                                        smsText: obj.smsText,
                                                        requestType: obj.requestType,
                                                        payload: obj.payload,
                                                        header: obj.header
                                                    };
                                                    return (
                                                        <option data-id={obj.id} value={JSON.stringify(valueObj)} key={idx}>
                                                            {obj.webhookName}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            {smsErrors[lable] && (
                                                <Form.Text className="text-danger">
                                                    {smsErrors[lable]}
                                                </Form.Text>
                                            )}
                                        </>
                                    )}
                                </Form.Group>
                            );
                        })
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={saveSmsData}>Save</Button>
                    <Button variant="secondary" onClick={closeSmsModal}>Discard</Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={menuAudioUrl}
                title={menuAudioName || "Menu Audio Preview"}
            />

        </div>
    );
};

export default DtmfNode;
